namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.AutomaticReports.MonitorAlertGrid')
    export class MonitorAlertGrid extends Serenity.EntityGrid<MonitorAlertRow, any> {
        protected getColumnsKey() { return MonitorAlertColumns.columnsKey; }
        protected getDialogType() { return MonitorAlertDialog; }
        protected getIdProperty() { return MonitorAlertRow.idProperty; }
        protected getInsertPermission() { return MonitorAlertRow.insertPermission; }
        protected getLocalTextPrefix() { return MonitorAlertRow.localTextPrefix; }
        protected getService() { return MonitorAlertService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}